import { createContext } from "react";

const PublicPageContext = createContext({});

export default PublicPageContext;
